import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import NavBar from 'components/layout/navbar';
import HeroImageCarousel from './scrollingHeroImages';
import { motion } from 'framer-motion';

export default function Header() {
  const titleVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 1.2,
        ease: 'easeOut',
        delay: 0.3,
      },
    },
  };

  const paragraphVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1,
        ease: 'easeOut',
        delay: 0.5,
      },
    },
  };

  const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.7,
      },
    },
  };

  return (
    <header className="bg-primary-light-4 bg-hero-pattern">
      <NavBar />

      <div className="flex flex-col items-center justify-center w-full mx-auto hero-text py-10 lg:py-16 px-4 lg:px-0">
        <motion.h1
          variants={titleVariants}
          initial="hidden"
          animate="visible"
          className="lg:max-w-4xl max-w-sm text-4xl lg:text-6xl text-center text-text-color tracking-normal font-medium"
        >
          We Put More{' '}
          <span className="font-serif italic text-primary font-semibold">
            Money{' '}
          </span>
          in
          <br></br>{' '}
          <span className="font-serif italic text-primary font-semibold">
            Women’s
          </span>{' '}
          Hands.
        </motion.h1>

        <motion.p
          variants={paragraphVariants}
          initial="hidden"
          animate="visible"
          className="max-w-sm px-4 lg:px-0  lg:max-w-lg text-center py-6 text-dark-grey text-base md:text-lg font-medium"
        >
          We’re a robust ecosystem that empowers women to overcome the financing
          challenges they face by providing financial solutions, mentorship, and
          access to a supportive network.
        </motion.p>

        <motion.a
          variants={buttonVariants}
          initial="hidden"
          animate="visible"
          href="/loan"
          className="inline-flex items-center rounded-full bg-text-color py-4 px-16 text-sm text-lg font-medium text-light-grey-4 drop-shadow-lg  transition duration-0 ease-in hover:drop-shadow-xl hover:duration-150"
        >
          Get Started
          <ChevronRightIcon className="ml-1 h-5 w-5 " aria-hidden="true" />
        </motion.a>
      </div>
      <HeroImageCarousel />
    </header>
  );
}
